export default __webpack_public_path__ + "static/media/menTshirt.2bdcbad4.svg";